<template>
<!-- <div class=""> -->
   <div class="basic_floating_frame_index module" :style="{
      ...background_style,
      ... position_style,
      width: `${width}px`,
      height: `${height}px`,
      ...box_show
    }"
    v-if="close_status"
    @dblclick.stop="edit_module"
    >
    <!-- :tabName="basic_floating_frame" -->
    <div class="tooptipPart tooptipPart_to_top" >
        <my_edit_btn
          :module="module"
          :title="$t('widgets_basic_article_classification_index_336')"
          
        ></my_edit_btn>
        <span
          class="sys_icon el-icon-view"
          :title="$t('view_back_top_index_105')"
          @click="hiddeFloatingFrame"
        ></span>
        <!-- <my_edit_btn
          :module="module"
          tabName="animation"
          title="动画设置"
        ></my_edit_btn> -->
       <!--  <my_link_btn
          :module="module"
          title="设置链接"
        ></my_link_btn> -->
        <!-- <my_close_btn
          :module="module"
          :column="column"
          :moduleIndex="module_index"
          title="删除模块"
        ></my_close_btn> -->
      
    </div>
    <i class=" close-icon" @click="frameClose" :style="{
      fontSize: closeBtnFontSize,
      width: closeBtnFontSize,
      height: closeBtnFontSize,
      lineHeight: closeBtnFontSize,
    }">×</i>
    <div class="frame-text" v-html="listArr.content"></div>
  </div>
<!-- </div> -->
</template>

<script type="text/javascript">
import i18n from '../../language/index'

import {background_set} from '@/base/background_set'
import {getBoxShadowStyle} from '@/utils/utils'
export default {
  name: 'basic_floating_frame',
  props: {
    module: {
      type: Object,
      default: null
    },
    column: {
      type: Object,
      default: null
    },
    row: {
      type: Object,
      default: null
    },
    module_index: {
      type: Number,
      default: 0
    }
  },
  data(){
    return {
      hover_status: false,
      close_status: false,
      close_timer: null,
      close_space: null
    }
  },
  computed:{
    pcWidgetsInfor() {
       return this.module.data.pc_widgets_infor
    },
    listArr(){
      return this.module.data.listArr
    },
    background_style() { // 背景图片
      return background_set(this.pcWidgetsInfor.background)
    },
    width(){ // 宽度
      return this.pcWidgetsInfor.width[this.pcWidgetsInfor.width.radio_val].width
    },
    height(){ // 宽度
      return this.pcWidgetsInfor.height[this.pcWidgetsInfor.height.radio_val].height
    },
    position_style(){ // 位置
      let position = this.pcWidgetsInfor.position.split('_')
      let detail = {}
      let num_position={
        left: '0px',
        center_r:`calc(50% - ${this.width/2}px)`,
        right: `calc(100% - ${this.width}px)`,
        top: '0px',
        center_c: `calc(50% - ${this.height/2}px)`,
        bottom:`calc(100% - ${this.height}px)`,
      }
      detail.left = (position[0] === 'center')?num_position.center_r : num_position[position[0]];
      detail.top = (position[1] === 'center')?num_position.center_c : num_position[position[1]];
      return detail
    },
    box_show(){ // 阴影设置
      return this.hover_status ? getBoxShadowStyle(this.pcWidgetsInfor.boxShadow, 'hover') :getBoxShadowStyle(this.pcWidgetsInfor.boxShadow)
    },
    playSet(){ // 多次的时候设置持续 和 间隔
      return this.pcWidgetsInfor.playSet
    },
    trigger(){
      return this.module.data.pc_widgets_infor.trigger
    },
    closeBtnFontSize(){
      return (18 + parseInt((this.width - 100)/100)) + 'px'
    }
  },
  mounted(){ 
    /* if(this.$store.state.main_dialog.main_dialog_isShow) { // 因为右侧编辑框发生变化的时候 会重新执行 mounted
       (this.$store.state.main_dialog.edit_name=="basic_floating_frame") &&(this.close_status = true);
       // 还是存在一个问题banner中有多个浮框 关闭一个之后再编辑另一个 这个浮框会被打开 这个地方 编辑框是这挂件的数据 进行处理
      // (this.$store.state.app.module_Data && this.$store.state.app.module_Data.widgets_id == this.module.widgets_id)&&(this.close_status = true);
    } else {
      let delay = this.playSet.delay;
      if(this.$store.state.app.view_pattern === 'pc')this.initData(delay)
    } */
    let delay = this.playSet.delay;
    if(this.$store.state.app.view_pattern === 'pc')this.initData(delay)

  },
  methods:{
    mouseenter() {
      this.hover_status = true
    },
    mouseleave(){
      this.hover_status = false
    },
    frameClose(){ //浮框关闭
      this.close_status =false
      if(this.$store.state.app.view_pattern === 'pc' && this.trigger === 'many'){
        let space = this.playSet.space;
        this.initData(space)
      }
    },
    initData(delay) {
      if(this.close_timer) {
        clearTimeout(this.close_timer);
        this.close_timer = null
      }
      let _this = this
      this.close_timer = setTimeout(()=>{
        _this.close_status = true;
      }, delay*1000)
    },
    edit_module() {
      this.templet.changeStyle(this.module)
    },
    hiddeFloatingFrame() {
      this.$store.state.myRender.private.floatingFrameOpen = false
      this.$store.commit("myRender/set_floating_frame_open", false)
      this.$store.commit('main_dialog/Change_main_dialog_isShow', false);
    }
  },
  watch: {
    '$store.state.app.view_pattern'(val){
      this.close_status = (this.$store.state.app.view_pattern === 'pc')
      if(val === 'mb') {
        this.close_timer && (clearTimeout(this.close_timer))
      }
      if(val === 'pc') {
        let delay = this.playSet.delay;
        this.initData(delay)
      }
    },
  },
  beforeDestroy(){ // 实例销毁 要 清除定时器
    // this.close_space && (clearInterval(this.close_space));
    this.close_timer && (clearTimeout(this.close_timer))
  }
};
</script>

<style scoped lang="scss">
.basic_floating_frame_index{
  position: fixed;
  z-index:1998;
  padding:35px 10px 10px 10px;
  //transition: all 0.3;
  transform:none;
  &:hover{
    .tooptipPart{
      display: block;
    }
  }
  .close-icon{
    position:absolute;
    top:8px;
    right:8px;
    font-size:18px;
    // color:#fff;
    background:#fff;
    border-radius:50%;
    width:20px;
    height:20px;
    text-align: center;
    line-height:20px;
    cursor: pointer;
  }
  .tooptipPart{
    /* left:0;
    top:0;
    width:62px; */
    // top:auto;
    .sys_icon {
      display: inline-block;
      vertical-align: top;
      width: 28px;
      height: 28px;
      color: #fff;
      font-size: 14px;
      line-height: 28px;
      text-align: center;
      background-color: #444;
      cursor: pointer;
      &:hover {
        background-color: #222;
      }
    }
  }
  .frame-text{
    font-size:12px;
    height:100%;
    overflow: auto;
    text-emphasis-color: hidden;
  }
}
</style>



// WEBPACK FOOTER //
// src/widgets/basic_floating_frame/index.vue